export enum TimePart {
  PM = 'PM',
  AM = 'AM',
}

export type Time = { hours: string; minutes: string; part: TimePart };
